import React from 'react';
import { Col, Button } from 'antd';
import { Droppable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import Training from './Training';

const ListOfTrainings = ({ columns, trainings, removeTraining, openAddModal, openBrowseModal, loadSamples, sampleTrainingsLoaded }) => {
  const printDroppable = (column) => (
    <Droppable droppableId={column.id}>
      {(provided, snapshot) => {
        const listClass = classNames('list-available', {
          'drag-over': snapshot.isDraggingOver,
        });
        return (
          <div ref={provided.innerRef} {...provided.droppableProps} className={listClass}>
            {column.trainingIds.map((trainId, index) => (
              <Training
                key={trainings[trainId].id}
                training={trainings[trainId]}
                index={index}
                removeTraining={removeTraining}
                openAddModal={openAddModal}
                columnId={column.id}
              />
            ))}
            {provided.placeholder}
          </div>
        );
      }}
    </Droppable>
  );

  return (
    <Col xs={24} lg={12} xl={8} className="base-available">
      <h3 className="section-title">Available Trainings</h3>
      <div className="base-available-content">
        <div className="base-available-content-scroll">
          <div className="buttons-container">
            <Button type="primary" onClick={() => openAddModal(null)} className="button">
              Add training
            </Button>
            <Button onClick={openBrowseModal} className="button">
              Browse
            </Button>
            <Button onClick={loadSamples} disabled={sampleTrainingsLoaded} className="button">
              {sampleTrainingsLoaded ? 'Sample trainings loaded' : 'Load sample trainings'}
            </Button>
          </div>
          {printDroppable(columns.available)}
        </div>
      </div>
    </Col>
  );
};

export default ListOfTrainings;
